import { qsa, all } from '../helpers/querySelector';
class HeightGroup {
    constructor(querySelector) {
        this.nodeList = qsa(querySelector);
        this.nodeHeights;
        this.newHeight;
    }

    watchElements(cb) {
        window.addEventListener('resize', () => {
            this.matchHeights(cb);
        });
        this.matchHeights(cb);
    }

    matchHeights(cb) {
        this.nodeHeights = [];
        this.newHeight = null;

        all(this.nodeList, el => {
            el.style.minHeight = 'auto';
            this.nodeHeights.push(el.offsetHeight);
        });

        this.newHeight = Math.max.apply(null, this.nodeHeights);
        all(this.nodeList, el => {
            el.style.minHeight = `${this.newHeight}px`;
        });

        if (typeof cb === 'function') cb();
    }
}

export default HeightGroup;



// WEBPACK FOOTER //
// ./assets/js/classes/HeightGroup.js